import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./wysiwygInput.component.html",
})
export class FormlyWysiwygInput extends FieldType<FieldTypeConfig> {}
